import { useState } from "react";
import { useHistory } from "react-router-dom";
import { UpdateOrganizationMutation } from "src/api/Organization";
import { BorderButton } from "src/components/buttons/BorderButton";
import CancelButton from "src/components/buttons/CancelButton";
import StepHeader from "src/components/forms/StepHeader";
import { InputText } from "src/components/inputs/InputText";
import Container from "src/components/layout/Container";
import OrganizationModel from "src/models/OrganizationModel";
import { apiClient } from "src/stores/Api";
import { useStore } from "src/stores/Store";
import message from "src/utils/message";
import { updateOrganizationVariables } from "types/code-generator";

interface Props {}

export default function UsaSwimming(props: Props) {
  const history = useHistory();
  const store = useStore();

  const [processing, setProcessing] = useState(false);

  // if (store.organization.usaSwimmingClubId) {
  //   return <Redirect to="/admin/usa-swimming/sync" />;
  // }

  const [usaSwimmingClubId, setUsaSwimmingClubId] = useState(
    store.organization.usaSwimmingClubId || ""
  );

  function onCancel() {
    history.goBack();
  }

  async function submit() {
    const variables: updateOrganizationVariables = {
      data: {
        usaSwimmingClubId,
      },
      where: {
        id: store.organization.id,
      },
    };

    setProcessing(true);
    const processingMessage = message.loading("Processing…");

    try {
      const update = await apiClient(UpdateOrganizationMutation, {
        variables,
      });

      processingMessage();
      setProcessing(false);

      if (update.updateOrganization?.usaSwimmingImport) {
        store.setOrganization(new OrganizationModel(update.updateOrganization));
        history.push(`/admin/usa-swimming/sync`);
      } else {
        message.error("There was an error. Please verify your Club ID.");
      }
    } catch (e) {
      processingMessage();
      setProcessing(false);
      message.error("There was an error. Please verify your Club ID.");
    }
  }

  return (
    <>
      <StepHeader>
        <div className="mb-2">
          <CancelButton onClick={onCancel} />
        </div>
        <p className="step-subhead">Connect to USA Swimming</p>
        <h2 className="mb-0">Link Club ID</h2>
      </StepHeader>

      <Container className="pb-12 pt-[100px]">
        <p className="mb-0 pt-4">
          <strong>How this works</strong>
        </p>
        <p>
          Connect your account, then we’ll automatically sync your members for
          your review.
        </p>

        <div className="mb-4 flex gap-2">
          <div className="flex h-6 w-6 items-center justify-center rounded-full border border-dark text-sm">
            1
          </div>
          <div className="flex-1">
            <strong>Set Captyn as your vendor in USA Swimming</strong>
            <div>While you’re there, copy your Club ID.</div>

            <div className="mt-4 flex gap-2">
              <BorderButton
                href="https://hub.usaswimming.org/landing"
                target="_blank"
              >
                <strong>Go now</strong>{" "}
                <i className="far fa-arrow-up-right-from-square ml-2 text-organization" />
              </BorderButton>
            </div>
          </div>
        </div>

        <div className="mb-6 flex gap-2">
          <div className="flex h-6 w-6 items-center justify-center rounded-full border border-dark text-sm">
            2
          </div>
          <div className="flex-1">
            <div className="mb-4">
              <strong>Enter your USA Swimming Club ID into Captyn</strong>
            </div>
            <InputText
              value={usaSwimmingClubId}
              onChange={setUsaSwimmingClubId}
              placeholder="USA Swimming Club ID"
            />
          </div>
        </div>

        <div className="flex gap-4">
          <BorderButton type="submit" onClick={submit} disabled={processing}>
            Submit
          </BorderButton>
          <BorderButton onClick={onCancel}>Cancel</BorderButton>
        </div>
      </Container>
    </>
  );
}
